const statusStyles = {
  Active: "bg-green-100 text-green-700",
  Planning: "bg-yellow-100 text-yellow-700",
  Completed: "bg-blue-100 text-blue-700",
  "On Hold": "bg-red-100 text-red-700",
  Draft: "bg-gray-100 text-gray-700",
  Cancelled: "bg-red-100 text-red-700",
};

const priorityStyles = {
  Critical: "bg-red-100 text-red-700",
  High: "bg-orange-100 text-orange-700",
  Medium: "bg-yellow-100 text-yellow-700",
  Low: "bg-green-100 text-green-700",
};

const executionStyles = {
  Hybrid: "bg-purple-100 text-purple-700",
  Work: "bg-blue-100 text-blue-700",
  Pipeline: "bg-indigo-100 text-indigo-700",
};

const ProjectRow = ({ project, onClick, onEdit }) => {
  return (
    <tr
      className="border-t hover:bg-gray-50"
      onClick={() => onClick?.(project)}
    >
      {/* PROJECT */}

      <td className="px-5 py-4">
        <div>
          <p className="font-semibold text-gray-800">
            {project?.project_name || "Unnamed Project"}
          </p>

          <p className="mt-1 text-xs text-blue-600">
            {project?.project_code || "—"}
          </p>
        </div>
      </td>

      {/* TYPE */}

      <td className="px-5 py-4 text-gray-600">
        {project?.project_type || "—"}
      </td>

      {/* STATUS */}

      <td className="px-5 py-4">
        <span
          className={`rounded-full px-3 py-1 text-xs font-semibold ${
            statusStyles[project?.status] ||
            "bg-gray-100 text-gray-700"
          }`}
        >
          {project?.status || "Draft"}
        </span>
      </td>

      {/* PRIORITY */}

      <td className="px-5 py-4">
        <span
          className={`rounded-full px-3 py-1 text-xs font-semibold ${
            priorityStyles[project?.priority] ||
            "bg-gray-100 text-gray-700"
          }`}
        >
          {project?.priority || "Medium"}
        </span>
      </td>

      {/* EXECUTION */}

      <td className="px-5 py-4">
        <span
          className={`rounded-full px-3 py-1 text-xs font-semibold ${
            executionStyles[project?.execution_mode] ||
            "bg-gray-100 text-gray-700"
          }`}
        >
          {project?.execution_mode || "—"}
        </span>
      </td>

      {/* START DATE */}

      <td className="px-5 py-4 text-gray-600">
        {project?.planned_start_date
          ? new Date(
              project.planned_start_date
            ).toLocaleDateString("en-IN")
          : "—"}
      </td>

      {/* ACTIONS */}

      <td
        className="px-5 py-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-center gap-2">
          {/* VIEW */}

          <button
            type="button"
            onClick={() => onClick?.(project)}
            className="rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-600 transition hover:border-blue-600 hover:bg-blue-600 hover:text-white"
          >
            View
          </button>

          {/* EDIT */}

          <button
            type="button"
            onClick={() => onEdit?.(project)}
            className="rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-600 transition hover:border-blue-600 hover:bg-blue-600 hover:text-white"
          >
            Edit
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ProjectRow;